function OffenderAlcoholImage() {
    "use strict";
    this.__type = 'OffenderAlcoholImage:www.veritracks.com';
    this.UpdateUTC = null;
    this.EnrolleeId = null;
    this.EnrolleeTimeZone = null;
    this.OrganizationId = null;
    this.ImageType = '';
    this.StartDate = null;
    this.StopDate = null;
    this.Name = '';
    this.ImageMatchedFlag = -1;
    this.ValidatedFlag = -1;
    this.Longitude = -1;
    this.Latitude = -1;
    this.ExternalId = '';
    this.ImageId = -1;
    this.Notes = '';
    this.AppUserId = null;
    this.IsActive = -1;
    this.Id = -1;
    this.VideoRequestedUserId = -1;
    this.VideoRequestedDate = null;

}
if (typeof exports !== 'undefined') {
    module.exports = OffenderAlcoholImage;
}